(() => {
  const sectionSelector = '[data-catalogue-quote-contact]';

  const cleanText = (value, maximum) => {
    const text = (value || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim();
    return Number.isFinite(maximum) ? text.slice(0, maximum) : text;
  };

  const initializeSection = (section) => {
    if (section.dataset.quoteInitialized === 'true') return;
    const message = section.querySelector('#contact_message');
    const productField = section.querySelector('#devis-produit-field');
    if (!message || !productField) return;
    section.dataset.quoteInitialized = 'true';

    let messageEdited = false;
    message.addEventListener('input', () => { messageEdited = true; });
    if (productField.value === '') productField.disabled = true;

    const labels = {
      product: section.dataset.quoteProductLabel,
      references: section.dataset.quoteReferencesLabel,
      url: section.dataset.quoteUrlLabel,
      quantity: section.dataset.quoteQuantityLabel,
    };

    const productUrl = (value, requireSameOrigin = false) => {
      if (!value) return null;
      try {
        const url = new URL(value, window.location.origin);
        const canonicalOrigin = new URL(section.dataset.quoteShopUrl).origin;
        const allowedOrigins = requireSameOrigin
          ? [window.location.origin]
          : [window.location.origin, canonicalOrigin];
        if (!['http:', 'https:'].includes(url.protocol)
          || !allowedOrigins.includes(url.origin)
          || url.username || url.password
          || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
        url.hash = '';
        return url;
      } catch {
        return null;
      }
    };

    const fill = (context) => {
      if (!context.product && !context.references && !context.url) return;
      const details = [
        `${labels.product} ${context.product || ''}`,
        `${labels.references} ${context.references || ''}`,
        `${labels.url} ${context.url || ''}`,
      ].join('\n');
      if (productField.value === '') {
        productField.value = details;
        productField.disabled = false;
      }
      if (message.value === '' && !messageEdited) {
        message.value = `${details}\n\n${labels.quantity} `;
        message.classList.add('catalogue-quote-message');
        message.dispatchEvent(new Event('input', { bubbles: true }));
      }
    };

    const parameters = new URLSearchParams(window.location.search);
    const product = cleanText(parameters.get('product'), 500);
    const subject = cleanText(parameters.get('subject'), 500);
    const explicitUrl = productUrl(parameters.get('url'));
    const context = {
      product: product || subject,
      references: cleanText(parameters.get('ref')),
      url: explicitUrl ? explicitUrl.href : '',
    };

    if (product || context.references || context.url) {
      fill(context);
      return;
    }

    const referrer = productUrl(document.referrer, true);
    if (!referrer || message.value !== '') {
      fill(context);
      return;
    }

    const productPath = referrer.pathname.match(/\/products\/([^/]+)\/?$/);
    const rootPath = (section.dataset.quoteRootUrl || '/').replace(/\/$/, '');
    const endpoint = new URL(`${rootPath}/products/${productPath[1]}.js`, window.location.origin);
    const variantId = referrer.searchParams.get('variant');

    fetch(endpoint.href, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error('Product context unavailable');
        return response.json();
      })
      .then((referrerProduct) => {
        const variants = Array.isArray(referrerProduct.variants) ? referrerProduct.variants : [];
        const selectedVariant = variantId
          ? variants.find((variant) => String(variant.id) === variantId)
          : null;
        const referenceVariants = variantId ? (selectedVariant ? [selectedVariant] : []) : variants;
        const references = [...new Set(referenceVariants
          .map((variant) => cleanText(variant.sku))
          .filter(Boolean))].join(', ');
        fill({
          product: cleanText(referrerProduct.title, 500),
          references,
          url: referrer.href,
        });
      })
      .catch(() => fill({ product: subject, url: referrer.href }));
  };

  const initialize = (scope = document) => {
    if (scope.matches?.(sectionSelector)) initializeSection(scope);
    scope.querySelectorAll(sectionSelector).forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
